var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-main"},[_c('div',{staticClass:"left-footer-content"},[_c('span',{staticClass:"text"},[_vm._v(" © "+_vm._s(_vm.edition)+" "),_vm._v("     备案号："+_vm._s(_vm.recordNumber))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }